/**
 * Dashboard API Endpoints
 * Endpoints for the main dashboard including arbitrage opportunities
 */

import apiClient from '../client';
import type { DashboardFinancialResponse } from '../types';

export const dashboardApi = {
  /**
   * GET /dashboard/financial
   * Get comprehensive dashboard data including arbitrage opportunities
   */
  getFinancialDashboard: async (): Promise<DashboardFinancialResponse> => {
    const response = await apiClient.get<DashboardFinancialResponse>(
      '/dashboard/financial'
    );
    return response.data;
  },
};
